import Routes from '@/router/Routes.ts';
import DashboardIcon from '@/components/icons/DashboardIcon';
import OrganizationIcon from '@/components/icons/OrganizationIcon';

export const companyAdminNavData = [
  {
    title: 'Dashboard',
    path: Routes.COMPANY__DASHBOARD,
    icon: <DashboardIcon />,
  },
  {
    title: 'Admins',
    path: Routes.COMPANY__ADMINS,
    icon: <OrganizationIcon />,
  },
];

export const navData = companyAdminNavData;

